// import React, { useEffect, useState } from 'react'
// import Footer from '../components/common/Footer'
// import { useParams } from 'react-router-dom'
// import {apiConnector} from '../services/apiconnector';
// import { categories } from '../services/apis';
// import { getCatalogPageData } from "../services/operations/pageAndComponentData"
// import Course_Card from '../components/core/Catalog/Course_Card';
// import CourseSlider from '../components/core/Catalog/CourseSlider';


// const Catalog = () => {
//     const {catalogName} = useParams();
//     const [catalogPageData, setCatalogPageData] = useState(null);
//     const [categoryId,setCategoryId] = useState("");

//     //fetch all categories
//    useEffect( () => {
//     const getCategories  = async () => {
//         const res = await apiConnector("GET",categories.CATEGORIES_API);
//         const category_Id =
//         res?.data?.data?.filter((ct)=> ct.name.split(" ").join("-").toLowerCase() === catalogName)[0]._id;
//         setCategoryId(category_Id);
//     }
//     getCategories();
//    },[catalogName]);
  
//    useEffect( () => {
//      const getCategoryDetails = async () => {
//         try{
//           const res  = await getCatalogPageData(categoryId);
//           console.log("Printing res: ",res)
//           setCatalogPageData(res);
//         }catch(error) {
//             console.log(error);
//         }
//      }
//      getCategoryDetails();
//    },[categoryId]);

//   return (
//     <div className='text-white'>

//     <div>
//     <p>{`Home / Catalog/`}<span>
//       {catalogPageData?.data?.selectedCategory?.name }
//     </span></p>
//     <p>{catalogPageData?.data?.selectedCategory?.name }
//     </p>
//     <p>{catalogPageData?.data?.selectedCategory?.description }
//     </p>
//     </div>

// <div> 
//     {/* Section 1 */}
//     <div>
//     <div>Courses to get you Started</div>
//         <div className='flex gapx-3'>
//             <h1>Most Popular</h1>
//             <p>New</p>
//         </div>
//         <CourseSlider  Courses={catalogPageData?.data?.selectedCategory?.courses}  />
//     </div>
     
//      <div>
//         {/* Section 2 */}
//         <div>
//             <p>Top Courses in  {catalogPageData?.data?.selectedCategory?.name }</p>
//             <div>
//                 <CourseSlider   Courses={catalogPageData?.data?.differentCategory?.courses}/>
//             </div>
//         </div>

//         {/* Section 3 */}
//         <div>
//             <div>Frequently Bought </div>
//             <div className='py-8'>

//               <div className='grid grid-cols-1 lg:grid-cols-2'>
//                 {
//                   catalogPageData?.data?.mostSellongCourses?.slice(0,4)
//                   .map((course, index) => {
//                     <Course_Card course={course} key={index} Height={"h-[400px]"}  />
//                   })
//                 }
//               </div>
//             </div>
//         </div>

//      </div>


//      </div>


//      <Footer />


//     </div>
//   )
// }

// export default Catalog




















import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"

// import CourseCard from "../components/core/Catalog/Course_Card"
// import CourseSlider from "../components/core/Catalog/CourseSlider"
import Footer from "../components/common/Footer"
import CourseCard from "../components/core/Catalog/Course_Card"
import CourseSlider from "../components/core/Catalog/CourseSlider"
import { apiConnector } from "../services/apiconnector"
import { categories } from "../services/apis"
import { getCatalogPageData } from "../services/operations/pageAndComponentData"
import Error from "./Error"

function Catalog() {
  const { loading } = useSelector((state) => state.profile)
  const { catalogName } = useParams()
  const [active, setActive] = useState(1)
  const [catalogPageData, setCatalogPageData] = useState(null)
  const [categoryId, setCategoryId] = useState("")
  // Fetch All Categories
  useEffect(() => {
    ;(async () => {
      try {
        const res = await apiConnector("GET", categories.CATEGORIES_API)
        const category_id = res?.data?.data?.filter(
          (ct) => ct.name.split(" ").join("-").toLowerCase() === catalogName
        )[0]._id
        setCategoryId(category_id)
      } catch (error) {
        console.log("Could not fetch Categories.", error)
      }
    })()
  }, [catalogName])
  useEffect(() => {
    if (categoryId) {
      ;(async () => {
        try {
          const res = await getCatalogPageData(categoryId)
          setCatalogPageData(res)
        } catch (error) {
          console.log(error)
        }
      })()
    }
  }, [categoryId])

  if (loading || !catalogPageData) {
    return (
      <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
        <div className="spinner"></div>
      </div>
    )
  }
  if (!loading && !catalogPageData.success) {
    return <Error />
  }

  return (
    <>
      {/* Hero Section */}
      <div className=" box-content bg-richblack-800 px-4">
        <div className="mx-auto flex min-h-[260px] max-w-maxContentTab flex-col justify-center gap-4 lg:max-w-maxContent ">
          <p className="text-sm text-richblack-300">
            {`Home / Catalog / `}
            <span className="text-yellow-25">
              {catalogPageData?.data?.selectedCategory?.name}
            </span>
          </p>
          <p className="text-3xl text-richblack-5">
            {catalogPageData?.data?.selectedCategory?.name}
          </p>
          <p className="max-w-[870px] text-richblack-200">
            {catalogPageData?.data?.selectedCategory?.description}
          </p>
        </div>
      </div>

      {/* Section 1 */}
      <div className=" mx-auto box-content w-full max-w-maxContentTab px-4 py-12 lg:max-w-maxContent">
        <div className="section_heading">Courses to get you started</div>
        <div className="my-4 flex border-b border-b-richblack-600 text-sm">
          <p
            className={`px-4 py-2 ${
              active === 1
                ? "border-b border-b-yellow-25 text-yellow-25"
                : "text-richblack-50"
            } cursor-pointer`}
            onClick={() => setActive(1)}
          >
            Most Populer
          </p>
          <p
            className={`px-4 py-2 ${
              active === 2
                ? "border-b border-b-yellow-25 text-yellow-25"
                : "text-richblack-50"
            } cursor-pointer`}
            onClick={() => setActive(2)}
          >
            New
          </p>
        </div>
        <div>
          <CourseSlider
            Courses={catalogPageData?.data?.selectedCategory?.courses}
          />
        </div>
      </div>
      {/* Section 2 */}
      <div className=" mx-auto box-content w-full max-w-maxContentTab px-4 py-12 lg:max-w-maxContent">
        <div className="section_heading">
          Top courses in {catalogPageData?.data?.selectedCategory?.name }
        </div>
        <div className="py-8">
          <CourseSlider
            Courses={catalogPageData?.data?.differentCategory?.courses}
          />
        </div>
      </div>

      {/* Section 3 */}
      <div className=" mx-auto box-content w-full max-w-maxContentTab px-4 py-12 lg:max-w-maxContent">
        <div className="section_heading">Frequently Bought</div>
        <div className="py-8">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            {catalogPageData?.data?.mostSellingCourses
              ?.slice(0, 4)
              .map((course, i) => (
                <CourseCard course={course} key={i} Height={"h-[400px]"} />
              ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default Catalog








